import { useListTableRowActionsContext } from "./list-table-row-actions.context";

export const useListTableRowActions = () => {
  const { setOpen } = useListTableRowActionsContext();

  return {
    closePopover: () => setOpen(false),
  };
};
